// i18n keys of the multi-tenant work package "world": the shared world (companies that work as one office).
// ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  cs_shared_world: 'Shared world',
  cs_shared_world_hint: 'Companies ticked here work as one office: they see each other’s documents and clients, keep the records that predate companies, and share one petty-cash box. Every other company sees only its own.',
  cs_shared_world_default: 'Not saved yet — the firms marked legal / accounting are shared.',
};
export const zh: Record<string, string> = {
  cs_shared_world: '共享工作区',
  cs_shared_world_hint: '勾选的公司作为同一个办公室运作：互相可见单据和客户，共同拥有建立公司之前的历史记录，并共用一个零用金账本。其他公司只能看到自己的数据。',
  cs_shared_world_default: '尚未保存 —— 目前默认共享标记为律所 / 会计所的公司。',
};
export const th: Record<string, string> = {
  cs_shared_world: 'พื้นที่ทำงานร่วม',
  cs_shared_world_hint: 'บริษัทที่เลือกไว้ทำงานเป็นสำนักงานเดียวกัน: เห็นเอกสารและลูกค้าของกันและกัน ถือบันทึกที่มีก่อนการแยกบริษัท และใช้สมุดเงินสดย่อยเล่มเดียวกัน บริษัทอื่นเห็นเฉพาะข้อมูลของตนเอง',
  cs_shared_world_default: 'ยังไม่ได้บันทึก — ขณะนี้บริษัทที่ระบุประเภทเป็นสำนักงานกฎหมาย / บัญชีจะใช้พื้นที่ร่วมกัน',
};
